import { useDispatch } from 'react-redux'
import { Box, Button, Modal } from '@mui/material'
import { useCreateUserMutation } from 'config/api/waV1_user';
import { toggleNoti, toggleError } from 'config/slice/message'
import React, { useCallback, useState } from 'react'
import { TYPE_EMAIL, TYPE_PASSWORD, TYPE_PASSWORD_VERIFY, TYPE_PHONE } from 'config/const/type';
import { useTranslation } from 'react-i18next';
import { KEY_ERROR_CREATE_FAILED, KEY_LABEL_CANCEL, KEY_LABEL_CREATE, KEY_LABEL_FORM_BOARD_NUM_NEW, KEY_NOTI_CREATE_SUCC, MODULE_PREVIEW_ROUTER_FORM } from 'config/const/locale';

const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

/**
 * tabel modal
 * @Todo i18n 
 * @param {Array[Object]} columns table definition data
 * @param {Function} dataSetter handler adding new a record to table data
 */
export default function TableModals({
    columns,
    dataSetter
}) {

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)
    const [closeToggle, setCloseToggle] = useState(true) // indicate Modal's state
    const [iptData, setIptData] = useState({
        [TYPE_EMAIL]: '',
        [TYPE_PHONE]: '',
        [TYPE_PASSWORD]: '123456',
        [TYPE_PASSWORD_VERIFY]: '123456'
    }) // form data for creating a new record
    const [createUserFn] = useCreateUserMutation()
    const dispatch = useDispatch()

    // toggle modal
    const modalToggleHandler = useCallback(() => setCloseToggle(prev => !prev), [])

    // input setter
    const IptSetter = (type) => (event) => setIptData(prev => ({ ...prev, [type]: event.target.value }))

    // create btn handler
    const createRecord = () => {
        // dataSetter(prev => [...prev, { ...iptData, id: prev?.length + 1 }])
        // createUserFn()
        //     .then(
        //         res => {

        //         }
        //     )
        createUserFn(iptData)
            .then(
                res => {
                    if (res.data?.data) {
                        dispatch(toggleNoti({
                            indicator: true,
                            msg: t(KEY_NOTI_CREATE_SUCC)
                        }))
                        window.location.reload()
                    }
                    else {
                        dispatch(toggleError({
                            indicator: true,
                            msg: t(KEY_ERROR_CREATE_FAILED)
                        }))
                    }
                }
            )
            .catch(
                reasion => {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_CREATE_FAILED)
                    }))
                }
            )
        modalToggleHandler()
    }

    return (
        <>
            <Button onClick={modalToggleHandler}>{t(KEY_LABEL_CREATE)}</Button>

            <Modal
                open={!closeToggle}
                onClose={modalToggleHandler}
            >
                <Box sx={style}>
                    <table style={{ width: "100%", textAlign: 'center', lineHeight: 2 }}>
                        {
                            columns.map(
                                i => i.id !== 'id' && (
                                    <tr key={i?.id} >
                                        <td style={{ paddingTop: 4 }}><label htmlFor={i.id}>{i.id}</label></td>
                                        <td><input type="text" id={i.id} name={i.id} onChange={IptSetter(i.id)} /></td>
                                    </tr>
                                )
                            )
                        }

                        <tfoot>
                            <tr>
                                <td></td>
                                <td style={{ paddingTop: 20 }}>
                                    <Button onClick={modalToggleHandler}>{t(KEY_LABEL_CANCEL)}</Button>
                                    <Button onClick={createRecord}>{t(KEY_LABEL_FORM_BOARD_NUM_NEW)}</Button>
                                </td>
                            </tr>
                        </tfoot>

                    </table>
                </Box>
            </Modal >

        </>
    )
}
